module.exports = __webpack_public_path__ + "img/banner4.688cd287.png";